module.exports = __webpack_public_path__ + "static/media/home_info.24eb4b23.png";